import React from "react";
import { useBeneficiaryDataLoader } from "./hooks/useBeneficiaryDataLoader";
import ProgressSteps from "./components/ProgressSteps";
import FileUploadStep from "./components/FileUploadStep";
import ProcessingStep from "./components/ProcessingStep";
import ReviewStep from "./components/ReviewStep";

const BeneficiaryDataLoader = () => {
  const {
    file,
    beneficiarios,
    beneficiaryData,
    isLoadingUpload,
    isLoadingSend,
    currentStep,
    showInvalidData,
    invalidRecords,
    setFile,
    setShowInvalidData,
    handleSubmit,
    handleClickConfirm,
    resetToFirstStep,
  } = useBeneficiaryDataLoader();

  return (
    <div
      className="w-full flex flex-col items-center justify-start overflow-y-auto mt-5
      [&::-webkit-scrollbar]:w-2
      [&::-webkit-scrollbar-track]:rounded-full
      [&::-webkit-scrollbar-track]:bg-gray-100
      [&::-webkit-scrollbar-thumb]:rounded-full
      [&::-webkit-scrollbar-thumb]:bg-gray-300"
    >
      <ProgressSteps currentStep={currentStep} onStepClick={resetToFirstStep} />

      {/* Etapa 1: Seleção do arquivo */}
      {currentStep === 1 && (
        <FileUploadStep
          file={file}
          onFileSelect={setFile}
          onSubmit={handleSubmit}
          isLoading={isLoadingUpload}
          beneficiaryData={beneficiaryData}
          beneficiarios={beneficiarios}
        />
      )}

      {/* Etapa 2: Processamento e Carregando */}
      {currentStep === 2 && (
        <ProcessingStep
          title="Processando arquivo"
          description="Aguarde enquanto validamos e processamos os dados..."
        />
      )}

      {/* Etapa 3: Revisão e Confirmação */}
      {currentStep === 3 && beneficiarios && (
        <ReviewStep
          beneficiarios={beneficiarios}
          invalidRecords={invalidRecords}
          showInvalidData={showInvalidData}
          onToggleInvalidData={setShowInvalidData}
          onConfirm={handleClickConfirm}
          isLoadingSend={isLoadingSend}
        />
      )}

      {/* Etapa 4: Conclusão */}
      {currentStep === 4 && (
        <ProcessingStep
          title="Salvando dados"
          description="Aguarde enquanto registramos os dados no sistema..."
        />
      )}
    </div>
  );
};

export default BeneficiaryDataLoader;
